var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4867AA;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.1,343.1h50.9l53.7,131h2.3l53.7-131h50.9v195h-40V411.2h-1.6l-50.5,126h-27.2l-50.5-126.5h-1.6v127.4h-40 V343.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.7,538.1v-195h131.4v34H366v46.5h83.4v34H366v46.6h90.6v34H324.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M471.9,377.1v-34h160.2v34h-59.7v161h-40.8v-161H471.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M658.6,538.1h-44.2l67.3-195h53.1l67.2,195h-44.2L709,387.7h-1.5L658.6,538.1z M655.8,461.5h104.4v32.2H655.8 V461.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaIcon);
export default __webpack_public_path__ + "static/media/meta_icon.d1c71d969c9df266884b9e097cafa74a.svg";
export { ForwardRef as ReactComponent };